import { formatCurrency } from '@coolblue-development/next-formatting-utils/core';
export function replaceInsuranceAttributePlaceholders({ attribute, liability, language, subsidiary, }) {
    const formattedDamageAmount = (liability === null || liability === void 0 ? void 0 : liability.damage)
        ? formatCurrency({ amount: liability.damage, language, subsidiary })
        : '';
    const formattedTheftAmount = (liability === null || liability === void 0 ? void 0 : liability.theft)
        ? formatCurrency({ amount: liability.theft, language, subsidiary })
        : '';
    return {
        ...attribute,
        name: attribute.name
            .replaceAll('{liability_damage}', formattedDamageAmount)
            .replaceAll('{liability_theft}', formattedTheftAmount),
        description: attribute.description
            .replaceAll('{liability_damage}', formattedDamageAmount)
            .replaceAll('{liability_theft}', formattedTheftAmount),
    };
}
//# sourceMappingURL=replacePlaceholders.js.map